import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource } from '@angular/material';

@Component({
  selector: 'app-spent-amount',
  templateUrl: './spent-amount.component.html',
  styleUrls: ['./spent-amount.component.scss']
})
export class SpentAmountComponent implements OnInit {

  @Input() dataSource
  @Input() caseData
  @Input() getExistingDetails

  // @Output() existingNegativeDetails = new EventEmitter<any>();
  @Output() existingNegativeDetails = new EventEmitter<any>();
  @Output() deletedTransaction = new EventEmitter<any>();
  spentTrasction = []
  negativeDetails = [];
  totalAmount = 0;
  spentTrasctionHeaders = ['item_id', 'date', 'name', 'category', 'account_id', 'amount']
  spentTrasctionFooter = []
  removedTransactionsDetails = []

  accountIds = [];
  accountNames = {};
  isAllSelect: boolean = false;
  selectedRow = []

  constructor() {

  }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.dataSource) {
      this.spentData()
    }
    if (this.caseData) {
      this.getCurrentBalance()
    }
    if (this.getExistingDetails) {
      this.submitForm()
    }
  }

  spentData() {
    // this.dataSource = this.caseTransaction
    (this.totalAmount)
    this.spentTrasctionFooter = ['Total', '', '', '', this.totalAmount]
  }

  getCurrentBalance() {
    let banks = this.caseData.plaid_accounts;
    let total = 0;
    let accountIds = [];

    if (banks === null) {
      // this.hideMe.emit('overview');
      return;
    }

    for (let i = 0; i < banks.length; i++) {
      for (let ii = 0; ii < banks[i].accounts.length; ii++) {

        total += banks[i].accounts[ii].balances.current;
        this.accountIds.push(banks[i].accounts[ii].account_id);
        this.accountNames[banks[i].accounts[ii].account_id] = banks[i].accounts[ii].name;

      }
    }
  }

  removeTransaction(transaction) {
    this.dataSource = this.dataSource.filter(item => item.transaction_id !== transaction.transaction_id)
    this.removedTransactionsDetails.push(transaction)

    this.negativeDetails = this.dataSource
  }

  submitForm() {
    this.existingNegativeDetails.emit(this.negativeDetails)
    this.deletedTransaction.emit(this.removedTransactionsDetails)
  }
  checkedToggle(transaction, event) {
    if (this.selectedRow.find(item => item.transaction_id === transaction.transaction_id)) {
      this.selectedRow = this.selectedRow.filter(element => element.transaction_id !== transaction.transaction_id)
    } else {
      this.selectedRow.push(transaction)
    }
  }

  removeSelectedRow() {
    this.selectedRow.forEach(item => {
      this.dataSource = this.dataSource.filter(element => element.transaction_id !== item.transaction_id)
      this.negativeDetails = this.dataSource
    })
    this.isAllSelect = false;
    this.selectedRow = []
  }

  selectAll() {
    this.isAllSelect = !this.isAllSelect;
    if (this.isAllSelect) {
      this.selectedRow = []
      this.selectedRow = this.dataSource
    } else {
      this.selectedRow = []
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/common/seven-one/component/spent-amount/spent-amount.component.ts